module.exports = __webpack_public_path__ + "static/media/logo-ideea-papel.247c8b85.png";